export default __webpack_public_path__ + "static/media/port15.18b3928b.jpg";